import Lenis from "lenis";

// https://github.com/darkroomengineering/lenis

if (document.body.dataset.playIntro !== undefined) {
  setTimeout(() => {
    window.scrollTo({ top: 0 });
  }, 100);
}

export const lenis = new Lenis({ lerp: 0.3 }) as Lenis;

export default () => {
  let hasScrolled = false;
  let introIsPlayed = false;

  function raf(time) {
    lenis.raf(time);
    requestAnimationFrame(raf);
  }

  if (document.body.dataset.playIntro !== undefined) {
    lenis.stop();

    setTimeout(() => {
      lenis.start();
      introIsPlayed = true;
    }, 2400);
  }

  lenis.on("scroll", () => {
    if (introIsPlayed && !hasScrolled) {
      document.body.classList.add("has-scrolled");
      hasScrolled = true;
    }
  });

  requestAnimationFrame(raf);
};
